import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import "./newbs.css"
import "./index.css"

const Update = ({ children }) => {
  return (
    <>
	<div className="col-12 shadow fixed-top bg-white shadow mb-5">
<ul className="nav justify-content-center">
  <li className="nav-item">
    <Link className="nav-link" title="aplikasi mesin kasir online website development" to="/">Mesin Kasir Online</Link>
  </li>
  

</ul></div>
<div className="col-12 text-right fixed-bottom">
  <Link to="#" title="to top"><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="currentColor" className="bi bi-arrow-up-circle-fill" viewBox="0 0 16 16">
  <path d="M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0zm-7.5 3.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11.5z"/>
</svg></Link>
</div>

      <div className="container-fluid">
	  <main>{children}</main>
		</div>
		
		<div className="container">
		<div className="row">
		<div className="col-md-6 p-3 p-md-5 mt-5 col-12">
	<h3 className="display-4"><strong><Link to="/">Mesin Kasir Online</Link></strong></h3>
		</div>
<div className="col-md-6 p-3 p-md-5 mt-3">
<div className="p-3 p-md-5">
		<h3>Contact</h3>
		<ul className="nav">
		<li className="nav-item"><a className="nav-link" href="https://wa.me/6285646104747">Whatsapp</a></li>
		<li className="nav-item"><a className="nav-link" href="tel:+62895339403223">Call Us</a></li>
		<li className="nav-item"><a className="nav-link" href="mailto:axcora@gmail.com">Email</a></li>
		<li className="nav-item"><a className="nav-link" href="https://goo.gl/maps/AesyjofbV3ARaH1T6" target="_blank" rel="noreferrer">Maps</a></li>
		</ul>
		</div>
		</div>
		</div>
		</div>
		
		<footer className="lead text-center"><p><small>
          © {new Date().getFullYear()}, <a href="/" title="mesin kasir online">mesinkasironline</a> | <small><Link to="/jadul">Oldschool</Link> | <Link to="/eng">Eng</Link></small><br/>Built with
          {` `}
          <a href="https://www.gatsbyjs.com" target="blank">Gatsby</a> develope by  <a href="https://www.fiverr.com/creativitas/create-your-website-with-new-technology" target="blank">Creativitas</a> Powered by  <a href="https://firebase.google.com/" target="blank">Firebase</a> </small></p>
        </footer>
    </>
  )
}

Update.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Update